import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface GendersParams extends DefaultHttpHeaders {}

@Injectable()
export class GendersService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining genders types
   * Service for obtaining genders types
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundGenderTypes
   */
  genders(params: GendersParams): Observable<ParameterResult[]> {
    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/genders',
    });
  }
}
